module.exports = __webpack_public_path__ + "img/person.226ac033.svg";